import { DecorationModel } from "../_model/DecorationModel";
import { ControllerTanque } from "../tanque/controllerTanque";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { COLORS } from "../../utils/colors";
import Resize from "../_decorationTools/risezeClass";
import * as d3 from "d3";
import { SingletonInter } from "../_service/singletonInter";

export class DecorationTanque extends DecorationModel {
  constructor() {
    super("DecorationTanque");
    this.node = null;
    this.ctr = new ControllerTanque();
    let resize = new Resize();

    this.init = async function(newNode, openDialog) {
      let svg = SingletonFlowchart.svg;
      this.dialog = openDialog
      this.node = newNode;

      await svg
        .data([newNode])
        .append("g")
        .attr("id", `${newNode.idName}`)
        .append("rect")
        .classed("Vat", true)
        .attr("x", (d) => d.x)
        .attr("y", (d) => d.y)
        .style("fill", COLORS.ClearBlue)

      let g = d3.select(`#${newNode.idName}`);

      g.append("image")
        .attr("width", newNode.width)
        .attr("height", newNode.height)
        .attr("x", newNode.xImg())
        .attr("y", newNode.yImg())
        .style("cursor", !newNode.readOnly ? "grab" : "crosshair")
        // Atualizando áreas automáticas SPRINT 6
        .attr("xlink:href", newNode.tanqueSelected ? require(`@/assets/Fluxogramas/${newNode.tanqueSelected}`) : newNode.srcImg)
        .on('dblclick', this.setDoubleClick)
        .on('click', this.setOnClick)
        .on("mouseover", resize.mouseOver)
        .on("mouseout", resize.mouseOut)
        .call(this.setDrag())
        .append("title")
          .text(SingletonInter.$t(newNode.title) )
        .node();

      resize.apply(g, newNode);

      return svg;
    };

    this.setDrag = function() {
      if (this.node.readOnly) return d3.drag();

      let that = this;

      let drag = d3
        .drag()
        .on("start", that.dragstarted)
        .on("drag", (event, d) => that.dragged(event, d))
        .on("end", that.dragended);

      return drag;
    };

    this.dragstarted = function(event, d) {
      SingletonFlowchart.selectNode(`${d.idName}`);
    };

    this.dragged = async function(event, d) {
      d.x = event.x;
      d.y = event.y;

      SingletonFlowchart.clicked = false;

      this.move();
    };

    this.move = async function() {
      await d3
        .select(`#${this.node.idName} > image`)
        .raise()
        .attr("x", this.node.xImg())
        .attr("y", this.node.yImg());      

      await d3
        .selectAll(`#${this.node.idName} > circle`)
        .raise()
        .attr("cx", this.node.x + this.node.width)
        .attr("cy", this.node.y + this.node.height);

      resize.move(this.node);
    };

    this.dragended = function() {
      SingletonFlowchart.SaveStatus();
    };

    this.update = function() {
      let d = this.node
      d3.select(`#${d.idName} > image`)
        .attr("xlink:href", require(`@/assets/Fluxogramas/${d.tanqueSelected}`))
        .attr("width", d.width)
        .attr("height", d.height)

      d3.select(`#${d.idName} > image > title`)
        .text(d.title)
    };
  }
}
